import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPSERT_WORKSPACE_KEY_VALUES: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation upsertWorkspaceKeyValues($input: UpsertWorkspaceKeyValuesInput!) {
    upsertWorkspaceKeyValues(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
